import { useRef } from 'react';

const useFormAccess = () => {
  const ref = useRef(null);

  const getFields = ({ scrollToInvalid } = {}) =>
    new Promise((resolve, reject) => {
      const { validateFields, validateFieldsAndScroll } = ref.current;
      const executor = scrollToInvalid ? validateFieldsAndScroll : validateFields;
      executor((err, values) => {
        if (err) {
          // eslint-disable-next-line prefer-promise-reject-errors
          reject({ formFieldErrors: err });
        } else {
          resolve(values);
        }
      });
    });
  return [ref, { getFields }];
};

export default useFormAccess;
